import React, { useCallback } from 'react';
import { useParticipantLeadRecord } from '../../../../data/hooks/leads/useParticipantLeadRecord';
import { useDebouncedSave } from '../../../../misc/useDebouncedSave/useDebouncedSave';
import LeadEmail from './LeadEmail';
import LeadName from './LeadName';
import LeadNotes from './LeadNotes';
import LeadPriority from './LeadPriority/LeadPriority';
import styles from './LeadRecord.module.scss';
import LeadTimeframe from './LeadTimeframe';
import LeadTitle from './LeadTitle';

function LeadRecord(props) {
    const { className = '', event, user, sponsorId, showName, editable } = props,
        lead = useParticipantLeadRecord(event?.id, sponsorId, user.participant_id),
        saveLead = useCallback((lead) => app.api.leads.update(event?.id, lead.scan_uuid, lead), [event?.id]),
        [leadState, setLeadState] = useDebouncedSave(lead, saveLead);

    const handleLeadChange = useCallback((changes) => {
        setLeadState((orig) => ({
            ...orig,
            ...changes,
        }));
    }, []);

    if (!lead) return null;

    return (
        <div className={[className, styles.LeadRecord].join(' ')}>
            <LeadTitle lead={leadState} />
            {showName ? <LeadName lead={leadState} /> : null}
            <LeadEmail lead={leadState} />
            {editable ? (
                <>
                    <div className={styles.layout}>
                        <LeadPriority lead={leadState} onChange={handleLeadChange} />
                        <LeadTimeframe lead={leadState} onChange={handleLeadChange} />
                    </div>
                    <LeadNotes lead={leadState} onChange={handleLeadChange} />
                </>
            ) : null}
        </div>
    );
}

export default LeadRecord;
